import { useGoogleLogin } from '@react-oauth/google'

import { useLogger } from '../useLogger/useLogger'

type UseGoogleCalendarAuthProps = {
  onSuccess: (code: string) => void
  onError: (error: Error) => void
}

export const useGoogleCalendarAuth = ({ onSuccess, onError }: UseGoogleCalendarAuthProps) => {
  const { logError } = useLogger()

  const connectCalendar = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async codeResponse => {
      const { code } = codeResponse
      onSuccess(code)
    },
    onError: error => {
      logError(error as Error)
      onError(error as Error)
    },
    scope: 'https://www.googleapis.com/auth/calendar'
  })

  return connectCalendar
}
